import axios from '@axios'
import useService from './useService'

const { jwt } = useService(axios, {})
export default jwt
